import PropTypes from 'prop-types';

// material-ui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';

// ==============================|| ADMİN GEÇİŞ - HATA BİLDİRİMİ ||============================== //
// target=true menü ögelerinde artık ayrı bir onay adımı yok: NavItem tıklanır
// tıklanmaz yeni sekme açılır ve arka planda auth/admin-gecis/ ile Django session'ı
// kurulup sekme doğrudan hedef sayfaya yönlendirilir. Bu modal yalnızca o çağrı
// başarısız olursa (yetkisizlik, ağ hatası vb.) gösterilir.

export default function AdminGecisModal({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Yönetim Paneli&apos;ne Geçilemedi</DialogTitle>
      <DialogContent>
        <Alert severity="error">Yönetim Paneli oturumu açılamadı. Yetkinizin olduğundan emin olun ve tekrar deneyin.</Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={onClose}>
          Tamam
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AdminGecisModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};
